/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import ModalCommon from "components/Modal/Modal";
import ModalContent from "./components/modalContent";
import Actions from "./components/actions";
import Tabs from "./components/tabs";
import SelectField from "components/SelectField";

const provinceOptions = [
  { value: "USD", label: "USD" },
  { value: "VNĐ", label: "VNĐ" },
];

export default function OilGas04() {
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);
  const [list, setList] = React.useState([{ name: "01/PL-DK", checked: false }]);

  const { formId, formField } = form;
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Tờ khai tạm tính tiền lãi dầu, khí nước chủ nhà (01/LNCN-PSC)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <TaxPersonalTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData, setFieldValue }) {
  const { formField, values, errors, touched } = formData;
  const {
    checkbox1,
    checkbox2,
    checkbox3,
    address,
    contract,
    district,
    email,
    fax,
    firstTime,
    phone,
    province,
    supplementaryForThe,
    taxCalculationPeriod,
    taxId,
    taxId2,
    taxId3,
    taxpayerName,
    unitType,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField
            name={checkbox1.name}
            label={checkbox1.label}
            value={Boolean(values.checkbox1)}
            onChange={(e) => {
              setFieldValue("checkbox1", Boolean(e.target.checked));
              setFieldValue("checkbox2", !Boolean(e.target.checked));
              setFieldValue("checkbox3", !Boolean(e.target.checked));
            }}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField
            name={checkbox2.name}
            label={checkbox2.label}
            value={Boolean(values.checkbox2)}
            onChange={(e) => {
              setFieldValue("checkbox2", Boolean(e.target.checked));
              setFieldValue("checkbox1", !Boolean(e.target.checked));
              setFieldValue("checkbox3", !Boolean(e.target.checked));
            }}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField
            name={checkbox3.name}
            label={checkbox3.label}
            value={Boolean(values.checkbox3)}
            onChange={(e) => {
              setFieldValue("checkbox3", Boolean(e.target.checked));
              setFieldValue("checkbox2", !Boolean(e.target.checked));
              setFieldValue("checkbox1", !Boolean(e.target.checked));
            }}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>

        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField
            name={firstTime.name}
            label={firstTime.label}
            value={Boolean(values.firstTime)}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={contract.name}
            label={contract.label}
            value={values.contract}
            error={errors.contract && touched.contract}
            success={values.contract?.toString().length > 0 && !errors.contract}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId2.name}
            label={taxId2.label}
            value={values.taxId2}
            error={errors.taxId2 && touched.taxId2}
            success={values.taxId2?.toString().length > 0 && !errors.taxId2}
          />
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address.name}
            label={address.label}
            value={values.address}
            error={errors.address && touched.address}
            success={values.address?.toString().length > 0 && !errors.address}
          />
        </Grid>
        <Grid item xs={12} lg={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            label={province.label}
            name={province.name}
            value={values.province}
            placeholder={province.placeholder}
            error={errors.province && touched.province}
            success={values.province.length > 0 && !errors.province}
          />
        </Grid>
        <Grid item xs={12} lg={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            label={district.label}
            name={district.name}
            value={values.district}
            placeholder={district.placeholder}
            error={errors.district && touched.district}
            success={values.district.length > 0 && !errors.district}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={phone.name}
            label={phone.label}
            value={values.phone}
            error={errors.phone && touched.phone}
            success={values.phone?.toString().length > 0 && !errors.phone}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={fax.name}
            label={fax.label}
            value={values.fax}
            error={errors.fax && touched.fax}
            success={values.fax?.toString().length > 0 && !errors.fax}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={email.name}
            label={email.label}
            value={values.email}
            error={errors.email && touched.email}
            success={values.email?.toString().length > 0 && !errors.email}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField
            name={checkbox1.name}
            label={checkbox1.label}
            value={Boolean(values.checkbox1)}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField
            name={checkbox2.name}
            label={checkbox2.label}
            value={Boolean(values.checkbox2)}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId3.name}
            label={taxId3.label}
            value={values.taxId3}
            error={errors.taxId3 && touched.taxId3}
            success={values.taxId3?.toString().length > 0 && !errors.taxId3}
          />
        </Grid>
        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            label={unitType.label}
            name={unitType.name}
            value={values.unitType}
            placeholder={unitType.placeholder}
            error={errors.unitType && touched.unitType}
            success={values.unitType.length > 0 && !errors.unitType}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
